module.exports = __webpack_public_path__ + "static/img/tab-one-active.75e96862.png";